import { render, staticRenderFns } from "./_part_medication.vue?vue&type=template&id=4b0e681f&scoped=true&lang=pug"
import script from "./_part_medication.vue?vue&type=script&lang=js"
export * from "./_part_medication.vue?vue&type=script&lang=js"
import style0 from "./_part_medication.vue?vue&type=style&index=0&id=4b0e681f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e681f",
  null
  
)

export default component.exports